import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { LiveThreats } from './pages/LiveThreats';
import { ThreatMap } from './pages/ThreatMap';
import { Fingerprints } from './pages/Fingerprints';
import { Deceptions } from './pages/Deceptions';
import { Intelligence } from './pages/Intelligence';
import { Agents } from './pages/Agents';
import { Settings } from './pages/Settings';
import { ReportsEnhanced as Reports } from './pages/ReportsEnhanced';
import { Quickstart } from './pages/Quickstart';
import { Canaries } from './pages/Canaries';
import { Actors } from './pages/Actors';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/quickstart" element={<Quickstart />} />
          <Route path="/threats" element={<LiveThreats />} />
          <Route path="/threat-map" element={<ThreatMap />} />
          <Route path="/actors" element={<Actors />} />
          <Route path="/fingerprints" element={<Fingerprints />} />
          <Route path="/deceptions" element={<Deceptions />} />
          <Route path="/canaries" element={<Canaries />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
